import { useContext } from 'react'
import { HeaderAdminContext } from '../contexts'

export function useHeaderAdmin() {
  const context = useContext(HeaderAdminContext)
  return context
}
